module.exports = __webpack_public_path__ + "img/company-icon.682edb46.svg";